var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('p',_vm._b({staticClass:"alert-msg"},'p',{ class: ( _obj = {}, _obj[_vm.align] = _vm.align, _obj ) },false),[_vm._v(_vm._s(_vm._f("errorMsg")(_vm.error.message)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }